import React, { useState } from 'react';
import classNames from 'classnames';

import lang from '../../../lib/language';

import searchIcon from '../../../assets/img/icon-search_white.svg';

import styles from './SearchMob.module.scss';

type Props = {
  searchStocks: (val: string) => void;
}

const SearchMob = ({ searchStocks }: Props) => {
  const [isFocused, setIsFocused] = useState(false);

  const wrapperStyles = classNames(
    styles.searchWrapper,
    isFocused && styles.focusedSearchWrapper,
  );

  return (
    <div className={wrapperStyles}>
      <img src={searchIcon} alt="" />
      <input
      // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        className={styles.input}
        placeholder={lang.commonOnboardingPhoneVerificationSearchCodePlaceholder()}
        type="search"
        onChange={(val) => searchStocks(val.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </div>
  );
};

export default SearchMob;
